import React, { FC } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';

import { LinkContainer } from '../../shared/navigation/NavigationLinksContainer';
import SubNavigationLayout from '../../shared/navigation/SubNavigationLayout';
import { NavigationLink } from '../../shared/navigation/NavigationLink';
import { useTranslation } from 'react-i18next';
import { useLocalContentProduct } from '../../api/local-content/collection/product/useLocalContentProduct';
import { useMatch, useNavigate } from 'react-router-dom';

const StLabelWithIcon = styled.div`
    font-size: 20px;
`;

type Props = {
    readonly isSticky: boolean;
};

const LocalContentNavigation: FC<Props> = ({ isSticky }) => {
    const lcProductDetailMatch = useMatch('/localcontent/products/:id');

    return lcProductDetailMatch ? (
        <LocalContentProductDetailsNav id={lcProductDetailMatch.params.id ?? ''} isSticky={isSticky} />
    ) : (
        <LocalContentDefaultNav isSticky={isSticky} />
    );
};

export default LocalContentNavigation;

const LocalContentDefaultNav: FC<Props> = ({ isSticky }) => {
    const { t } = useTranslation();

    return (
        <SubNavigationLayout
            left={
                <StLabelWithIcon className={classNames('material-link')}>
                    <i className="material-icons" aria-hidden={true}>
                        place
                    </i>
                    <span>{t('menu.yourBorrowbox.yourLocalContent.localContentCollection')}</span>
                </StLabelWithIcon>
            }
            center={
                <LinkContainer>
                    <li>
                        <NavigationLink to="/localcontent/collection" className="material-link">
                            <span>{t('menu.yourBorrowbox.yourLocalContent.localContentCollection')}</span>
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to="/localcontent/products">
                            {t('menu.yourBorrowbox.yourLocalContent.yourTitles')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to="/localcontent/performers">
                            {t('menu.yourBorrowbox.yourLocalContent.yourAuthors')}
                        </NavigationLink>
                    </li>
                </LinkContainer>
            }
            isSticky={isSticky}
            width="30"
        />
    );
};

const LocalContentProductDetailsNav: FC<Props & { id: string }> = ({ id, isSticky }) => {
    const navigate = useNavigate();
    const { data: product } = useLocalContentProduct(id);

    return (
        <SubNavigationLayout
            left={
                product?.title ? (
                    <StLabelWithIcon>
                        <div>
                            <a
                                onClick={() => {
                                    navigate(-1);
                                }}
                                className="back fl-left"
                            >
                                <i className="material-icons bigger" aria-label="Go back">
                                    arrow_back
                                </i>
                            </a>
                            {product.title}
                        </div>
                    </StLabelWithIcon>
                ) : null
            }
            isSticky={isSticky}
            width="30"
        />
    );
};
